module.exports = __webpack_public_path__ + "assets/img/usdr.2043d612.png";